"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var CamIcon = function CamIcon() {
  return _react2.default.createElement(
    "svg",
    { viewBox: "0 0 12 12", version: "1.1", className: "quiver-cam-icon" },
    _react2.default.createElement(
      "g",
      { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { id: "cam-icon", fill: "#96A9B2" },
        _react2.default.createElement("path", { d: "M12,3 L12,9 L9,7.09090909 L9,4.90909091 L12,3 Z M9,8.93333333 C9,9.5224 8.53945714,10 7.97142857,10 L1.02857143,10 C0.460542857,10 0,9.5224 0,8.93333333 L0,3.06666667 C0,2.4776 0.460542857,2 1.02857143,2 L7.97142857,2 C8.53945714,2 9,2.4776 9,3.06666667 L9,8.93333333 Z" })
      )
    )
  );
};

exports.default = CamIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamIcon/CamIcon.js
// module id = 270
// module chunks = 0